enum KemActionTypes {
  UPDATE_APP_KEM_STATE = "UPDATE_APP_KEM_STATE",
  LOGOUT = "LOGOUT",
}

export default KemActionTypes;
